import {Project} from '@mintdata-wsp/common/state/DataState';
import {rootState} from '@mintdata-wsp/common/state/RootState';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {paths} from '@mintdata-wsp/wsp/ui/routes/Routing';
import {SpaceDotsMenu} from '@mintdata-wsp/wsp/ui/views/workspace/home/sidebar/spaces/SpaceDotsMenu';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import * as React from 'react';
import {NavLink} from 'react-router-dom';

const styles = require('./SidebarSpaces.less');
const cx = classnames.bind(styles);

interface Props
{
    project:Project;
    onRef?:(projectId:number, elementRef:HTMLElement)=>void;
}

@observer
export class SidebarSpacesItem extends React.Component<Props, any>
{
    private _onClick = (e:React.MouseEvent<HTMLElement>) =>
    {
        controllers.ui.mainPage.setMobileMenuVisibility(false);
    };

    private _onItemRef(projectId:number, elementRef:HTMLElement)
    {
        if( this.props.onRef )
            this.props.onRef(projectId, elementRef);
    }

    render():JSX.Element
    {
        // do not remove: need for update component
        const {locationMatch} = rootState.ui.mainPage;

        const {project} = this.props;

        return (
            <div
                key={project.id}
                className={styles.project}
                ref={(elementRef) => this._onItemRef(project.id, elementRef)}
            >
                <div className={styles.linkWrapper}>
                    <NavLink
                        exact={true}
                        to={paths.spaces(project.id)}
                        className={styles.link}
                        activeClassName={styles.active}
                        onClick={this._onClick}
                    >
                        {project.name}
                    </NavLink>
                </div>
                {/*<DotsMenu*/}
                {/*    className={styles.dotsMenu}*/}
                {/*    popupClassName={styles.dotsMenuPopup}*/}
                {/*    menuItems={this._menuItems}*/}
                {/*/>*/}
                <SpaceDotsMenu
                    className={styles.dotsMenu}
                    project={project}
                />
            </div>
        );
    }
}
